export interface ProductViewState {
  uiProductSidebarOpened: boolean;
  uiProductSidebarRightOpened: boolean;
  multiEditEnabled: boolean;
  multiEditSelectedEntityTypeKey: string | null;
  multiEditSelectedEntityIds: string[];
  multiEditSelectedHoodIds: string[];
  openHoodLinePanelIds: string[];
  hoodSettingsOpened: boolean;
  overlappingLineIds: string[];
}

export const initialState: ProductViewState = {
  uiProductSidebarOpened: true,
  uiProductSidebarRightOpened: true,
  multiEditEnabled: false,
  multiEditSelectedEntityIds: [],
  multiEditSelectedEntityTypeKey: null,
  multiEditSelectedHoodIds: [],
  openHoodLinePanelIds: [],
  hoodSettingsOpened: true,
  overlappingLineIds: []
};
